import React, { useEffect, useState } from 'react'
import { Select, InputNumber } from 'antd'
import { useDispatch, useSelector } from 'react-redux'
import { DatabaseOutlined } from '@ant-design/icons'

import { useUpdate, useValidation, Widget } from './base/widget'
import { CommonFields } from './base/widgetCommonFields'
import { FormItem, styleIconValidation, ValidatedSelect } from './base/styles'
import { object } from 'prop-types'
import { listDatabases } from 'states/modules/internalDatabase'

export const InternalInternalDatabaseWidget = React.memo((props) => {
	const { data } = props
	const internalDatabase = useSelector(
		({ internalDatabase }) => internalDatabase
	)
	const dataItems = internalDatabase.data

	const dispatch = useDispatch()

	const update = useUpdate(props)
	const [valid, setValid] = useValidation(props)
	const [databaseValid, setDatabaseValid] = useState(false)
	const [widget, setWidget] = useState(false)

	useEffect(() => {
		dispatch(listDatabases({ perPage: 100 }))
	}, [dispatch])

	useEffect(() => {
		setDatabaseValid(dataItems ? dataItems.length > 0 : false)

		setValid(databaseValid && widget)
	}, [databaseValid, widget, setValid, dataItems])

	const handleSearch = (_value) => {
		// TODO: implement search
	}

	return (
		<Widget
			{...props}
			type={'Novo Banco de dados'}
			icon={<Icon $error={!valid} />}
			onValidate={setWidget}
			formItems={
				<div>
					<CommonFields data={data} update={update} hasDescription={false} />
					<FormItem label="Widget" $labelWidth="fit-content">
						<ValidatedSelect
							value={data.typeWidget === '' ? undefined : data.typeWidget}
							onChange={(v) => update({ typeWidget: v })}
							placeholder={'Selecione um tipo de exibição'}>
							<Select.Option value="list">Lista</Select.Option>
							<Select.Option value="checkbox">Checkbox</Select.Option>
						</ValidatedSelect>
					</FormItem>
					<FormItem label="Máximo" $labelWidth="fit-content">
						<InputNumber
							min={0}
							onBlur={(e) => update({ maximum: e.target.value })}
							defaultValue={data.maximum}
							autoComplete="off"
							style={{ width: '100%' }}
						/>
					</FormItem>
					<FormItem label="Mínimo" $labelWidth="fit-content">
						<InputNumber
							min={0}
							onBlur={(e) => update({ minimum: e.target.value })}
							defaultValue={data.minimum}
							autoComplete="off"
							style={{ width: '100%' }}
						/>
					</FormItem>

					<FormItem label="Banco de dados" $labelWidth="fit-content">
						<ValidatedSelect
							$error={!databaseValid}
							$placeholderError={!databaseValid}
							value={data.databaseId === '' ? undefined : data.databaseId}
							onChange={(v) => update({ databaseId: v })}
							placeholder={
								databaseValid
									? 'Selecione um banco de dados'
									: 'Nenhum banco de dados encontrado'
							}>
							{dataItems
								? dataItems.map((item, i) => (
										<Select.Option key={i} value={item.id}>
											{item.title}
										</Select.Option>
									))
								: null}
						</ValidatedSelect>
					</FormItem>
					<FormItem label="Filtros" $labelWidth="fit-content">
						<ValidatedSelect
							mode="multiple"
							value={data.filter === '' ? undefined : data.filter}
							onChange={(v) => update({ filter: v })}
							onSearch={handleSearch}
							filterOption={false}
							loading={internalDatabase.tags.loading}
							notFoundContent={
								internalDatabase.tags.loading
									? 'Carregando...'
									: 'Nenhum item encontrado'
							}></ValidatedSelect>
					</FormItem>
				</div>
			}
		/>
	)
})

const Icon = styleIconValidation(DatabaseOutlined)

InternalInternalDatabaseWidget.propTypes = {
	data: object,
}
